/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_VercelInputs */

const en_svchip_vercel = /** @type {(inputs: Svchip_VercelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vercel`)
};

const ar_svchip_vercel = /** @type {(inputs: Svchip_VercelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vercel`)
};

const bn_svchip_vercel = /** @type {(inputs: Svchip_VercelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vercel`)
};

const de_svchip_vercel = /** @type {(inputs: Svchip_VercelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vercel`)
};

const es_svchip_vercel = /** @type {(inputs: Svchip_VercelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vercel`)
};

const fr_svchip_vercel = /** @type {(inputs: Svchip_VercelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vercel`)
};

const pt_svchip_vercel = /** @type {(inputs: Svchip_VercelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vercel`)
};

const zh_svchip_vercel = /** @type {(inputs: Svchip_VercelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`韦尔塞尔`)
};

const tr_svchip_vercel = /** @type {(inputs: Svchip_VercelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vercel`)
};

const ru_svchip_vercel = /** @type {(inputs: Svchip_VercelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Версель`)
};

const pl_svchip_vercel = /** @type {(inputs: Svchip_VercelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vercel`)
};

/**
* | output |
* | --- |
* | "Vercel" |
*
* @param {Svchip_VercelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_vercel = /** @type {((inputs?: Svchip_VercelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_VercelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_vercel(inputs)
	if (locale === "bn") return bn_svchip_vercel(inputs)
	if (locale === "de") return de_svchip_vercel(inputs)
	if (locale === "es") return es_svchip_vercel(inputs)
	if (locale === "fr") return fr_svchip_vercel(inputs)
	if (locale === "pt") return pt_svchip_vercel(inputs)
	if (locale === "zh") return zh_svchip_vercel(inputs)
	if (locale === "tr") return tr_svchip_vercel(inputs)
	if (locale === "ru") return ru_svchip_vercel(inputs)
	if (locale === "pl") return pl_svchip_vercel(inputs)
	return en_svchip_vercel(inputs)
});